// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-484da0ea{to{stroke-dashoffset:0}}.image-banner-ad-container[data-v-484da0ea]{align-items:center;display:flex;flex-direction:column;gap:1rem;justify-content:center}.image-banner-ad-container[data-v-484da0ea]:not(:empty){padding:1rem}.image-banner-ad-container .list-item img[data-v-484da0ea]{max-width:100%}.image-banner-ad-container .item-link[data-v-484da0ea]{display:inline-block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
